<form-control
  (inputChanged)="onIndustryTitleInput($event)"
  (selected)="onIndustryTitleSelect($event)"
  [group]="formGroup"
  [direction]="direction"
  [config]="industryTitleConfig"
  [control]="formGroup.get(industryTitleProp)"
  data-test-id="industryTitleFormControl"
>
  @if (formGroup.get(industryTitleProp).valid && loadingIndustryTitle) {
    <p
      hint
      class="u-absolute t-caption"
      data-test-id="industryTitleLoadingMessage"
    >
      {{ industryTitleConfig.messages.loading }}
    </p>
  }
  @if (
    formGroup.get(industryTitleProp).valid &&
    !loadingIndustryTitle &&
    showIndustryTitleError
  ) {
    <p
      hint
      class="u-absolute t-caption t-error"
      data-test-id="industryTitleErrorMessage"
    >
      {{ industryTitleConfig.messages.error }}
    </p>
  }
</form-control>

<form-control
  (inputChanged)="onSICCodeInput($event)"
  (selected)="onSICCodeSelect($event)"
  [group]="formGroup"
  [direction]="direction"
  [config]="sicCodeConfig"
  [control]="formGroup.get(sicCodeProp)"
  data-test-id="sicCodeFormControl"
>
  @if (formGroup.get(sicCodeProp).valid && loadingSicCodes) {
    <p hint class="u-absolute t-caption" data-test-id="sicCodeLoadingMessage">
      {{ sicCodeConfig.messages.loading }}
    </p>
  }
  @if (
    formGroup.get(sicCodeProp).valid && !loadingSicCodes && showSicCodeError
  ) {
    <p
      hint
      class="u-absolute t-caption t-error"
      data-test-id="sicCodeErrorMessage"
    >
      {{ sicCodeConfig.messages.error }}
    </p>
  }
</form-control>
